import * as React from "react";
import { useEffect, useRef, useState } from "react";
import {
    RemoteParticipant,
    RemoteVideoStream,
    VideoStreamRenderer,
    VideoStreamRendererView
} from "@azure/communication-calling";
import { Avatar, MicIcon, MicOffIcon } from "@fluentui/react-northstar";

const RemoteParticipantView: React.FC<{ participant: RemoteParticipant }> = ({ participant }) => {
    const videoContainerRef = useRef<HTMLDivElement>(null);
    const rendererRef = useRef<VideoStreamRenderer | null>(null);
    const viewRef = useRef<VideoStreamRendererView | null>(null);
    const [isMuted, setIsMuted] = useState(participant.isMuted);
    const [activeStream, setActiveStream] = useState<RemoteVideoStream | null>(null);

    const tryRenderVideo = async (stream: RemoteVideoStream) => {
        if (!stream.isAvailable || !videoContainerRef.current) return;

        rendererRef.current?.dispose();
        const renderer = new VideoStreamRenderer(stream);
        const view = await renderer.createView();

        rendererRef.current = renderer;
        viewRef.current = view;

        videoContainerRef.current.innerHTML = '';
        videoContainerRef.current.appendChild(view.target);
    };

    useEffect(() => {
        const videoStreams = participant.videoStreams;
        const handlers: { stream: RemoteVideoStream; handler: () => void }[] = [];

        const updateActiveStream = () => {
            const available = videoStreams.find(s => s.isAvailable);
            setActiveStream(available ?? null);
        };

        videoStreams.forEach(stream => {
            const handler = () => {
                console.log(stream);
                console.log(`Stream ${stream.id} availability: ${stream.isAvailable}`);
                updateActiveStream();
            };
            stream.on('isAvailableChanged', handler);
            handlers.push({ stream, handler });
        });

        updateActiveStream();

        const handleMuteChanged = () => {
            console.log("Mudo mudou:", participant.isMuted);
            setIsMuted(participant.isMuted);
        };

        participant.on('isMutedChanged', handleMuteChanged);

        return () => {
            handlers.forEach(({ stream, handler }) => {
                stream.off('isAvailableChanged', handler);
            });

            participant.off('isMutedChanged', handleMuteChanged);

            rendererRef.current?.dispose();
            rendererRef.current = null;
            viewRef.current = null;
        };
    }, [participant]);

    useEffect(() => {
        if (activeStream) {
            tryRenderVideo(activeStream);
        } else {
            rendererRef.current?.dispose();
            rendererRef.current = null;
            viewRef.current = null;
            if (videoContainerRef.current) {
                videoContainerRef.current.innerHTML = '';
            }
        }
    }, [activeStream]);

    return (
        <div className={`${!activeStream ? 'remote-video-container' : 'remote-video-container-stream'}`}>
            {activeStream ? (
                <div ref={videoContainerRef} className="remote-video"></div>
            ) : (
                <Avatar size="largest" name={participant.displayName ?? 'Participante'} />
            )}

            <div className="remote-footer">
                <span className="remote-name">{participant.displayName ?? 'Participante'}</span>
                {isMuted ? (
                    <MicOffIcon size="small" styles={{ marginLeft: '4px' }} />
                ) : (
                    <MicIcon size="small" styles={{ marginLeft: '4px' }} />
                )}
            </div>
        </div>
    );
};

export default RemoteParticipantView;
